<template>
    <div>
        <v-container fluid class="category-bg d-flex align-center" :style="categoryHeaderStyle.style" :class="categoryHeaderStyle.class">
            <v-container>
                <template v-if="manufacturer">
                    <div class="d-flex align-center justify-center ga-3">
                        <v-img
                            :width="140"
                            :src="manufacturer.main_image.url"
                            class="flex-grow-0"
                            aspect-ratio="1.75"
                            :alt="manufacturer.main_image?.alt"
                        ></v-img>
                        <h1 class="text-h4 py-8 text-center text-uppercase">{{$tChoice('eshop::group-page.manufacturers', 0)}} {{
                                manufacturer.name
                            }}{{ !is_main ? ` - ${group.name}` : '' }}</h1>
                    </div>
                </template>
                <h1 v-else class="text-h4 py-8 text-center">{{ group.name }}</h1>
            </v-container>
        </v-container>
        <breadcrumb :items="breadcrumb"></breadcrumb>
        <v-container v-if="group.text">
            <div v-html="group.text"></div>
            <v-divider class="mt-4"></v-divider>
        </v-container>
        <subgroups v-if="subgroups?.length" :subgroups="subgroups"></subgroups>
        <slot></slot>
        <v-container v-if="last_visited?.length">
            <v-row>
                <v-col>
                    <last-visited :lastVisited="last_visited"></last-visited>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script setup>
import { computed, defineAsyncComponent } from 'vue';
import Breadcrumb from "../../../frontend/components/Breadcrumb.vue";
import Subgroups from "../frontend/Subgroups.vue";

const props = defineProps({
    subgroups: Array,
    last_visited: Array,
    defaultCategoryHeader: Object,
    group: Object,
    breadcrumb: Array,
    manufacturer: Object,
    is_main: Boolean,
})

const LastVisited = defineAsyncComponent(() => import('../frontend/LastVisited.vue'))
const categoryHeaderStyle = computed(() => {
    const url = props.group?.category_header?.url || props.defaultCategoryHeader?.url;

    return {
        style: url ? { backgroundImage: `url(${url})` } : {},
        class: url ? 'has-custom-bg' : ''
    };
});
</script>

<style scoped lang="scss">
.category-bg {
    background-image: url('../../../assets/category-header.webp');
    background-position: center;
    background-size: cover;
    &.has-custom-bg {
        background-blend-mode: darken;
        background-size: cover;
        background-color: rgba(0, 0, 0, .4);
        color: white;
    }
}
</style>
